import React from 'react'

import GroupWrapper from '../../components/GroupWrapper'
import Flex from '../../../../../components/layouts/Flex'

import RecruitmentTypeBreakdown from './RecruitmentTypeBreakdown'
import RecruitmentStageBreakdown from './RecruitmentStageBreakdown'
import SourcingChannelEffectiveness from './SourcingChannelEffectiveness'
import AgingDays from './AgingDays'
import RoleStatusBreakdownList from './RoleStatusBreakdownList'
import RecruiterRatioList from './RecruiterRatioList'

const MonthlyTables = () => {
    return (
        <GroupWrapper title="Tables - Overview">
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentTypeBreakdown />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentStageBreakdown />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <SourcingChannelEffectiveness />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <AgingDays />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RoleStatusBreakdownList />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruiterRatioList />
            </Flex>
        </GroupWrapper>
    )
}

export default MonthlyTables
